<template>
  <div class="anketa-2cols">
    <span class="title">{{ title}}</span>
    <div>
      <EyeBlock :data="datas" @isSelected="isSelected()"></EyeBlock>
    </div>
    <primary-button
        @click="saveStep(button.link); events();"
        :disabled="disabled"
        :text="button.text"
        :link="button.link" />
  </div>
</template>

<script>
import EyeBlock from "@/components/Anketa/EyeBlock";
import eyeData from "@/data/anketa/eyeData";
import { useHeaderStore } from '@/stores/header'
import headerMixin from "@/mixins/headerMixin";
import {useSettingsStore} from "@/stores/settings";
import selectedMixin from "@/mixins/selectedMixin";
import {useApiStore} from "@/stores/api";
import {useAnketaStore} from "@/stores/anketa";

export default {
  name: 'EyeQuestionView',
  components: {EyeBlock},
  mixins: [headerMixin, selectedMixin],
  props: ['header'],
  setup() {
    const {setHeaderData} = useHeaderStore();
    const settings = useSettingsStore();
    const api = useApiStore();
    const anketaStore = useAnketaStore();
    return {setHeaderData, settings,api, anketaStore};
  },
  methods:{
    async events() {
      const isEdit = this.anketaStore.isFinished();
      const fromPage = this.anketaStore.formFromPage ?? null;
      await this.api.onStageEvent('onFormStage', 'question_3', isEdit ? false : null, fromPage);
    }
  },
  data(){
    return {
      stepId: 'eye_color',
      title: 'А какой у тебя цвет глаз?',
      button:{
        text: 'Продолжить',
        link: 'anketa.step3',
      },
    }
  }
}
</script>
